import React, { useContext, useMemo } from 'react';
import MessageContext, { defaultValue } from './message-context';

function getLocales(_ref, locale) {
  var locales = _ref.locales;
  var fallback = locales.filter(function (fb) {
    return fb !== locale;
  });
  return [locale].concat(fallback);
}

function getMessages(_ref2, locale, lcMessages) {
  var merge = _ref2.merge,
      messages = _ref2.messages;
  var res = Object.assign({}, messages);
  var prev = res[locale];
  res[locale] = prev ? merge({}, prev, lcMessages) : lcMessages;
  return res;
}

function getPathSep(context, pathSep) {
  return pathSep === null || typeof pathSep === 'string' ? pathSep : context.pathSep;
}

function MessageProvider(_ref3) {
  var children = _ref3.children,
      parent = _ref3.context,
      locale = _ref3.locale,
      merge = _ref3.merge,
      messages = _ref3.messages,
      pathSep = _ref3.pathSep;
  if (parent === undefined) parent = useContext(MessageContext);else if (parent === null) parent = defaultValue;
  var context = useMemo(function () {
    return {
      locales: getLocales(parent, locale),
      merge: merge || parent.merge,
      messages: getMessages(parent, locale, messages),
      pathSep: getPathSep(parent, pathSep)
    };
  }, [parent, locale, merge, messages, pathSep]);
  return React.createElement(MessageContext.Provider, {
    value: context
  }, children);
}

MessageProvider.defaultProps = {
  locale: ''
};
export default MessageProvider;